(function() {
  const API_BASE = 'https://api-live.sokora.com';
  const AUTH_TOKEN = 'ym-sokara-5295f1883ce92a6fa988e9c9c1113bd8';

  const STEPS = [
    { key: 'ORDER_PLACED', label: 'Confirmed', icon: 'check' },
    { key: 'PICKED_UP', label: 'Packed', icon: 'box' },
    { key: 'INTRANSIT', label: 'On its way', icon: 'truck' },
    { key: 'DELIVERED', label: 'Delivered', icon: 'home' },
  ];

  const STATUS_LABELS = {
    ORDER_PLACED: 'Order Placed',
    AWB_REGISTERED: 'AWB Registered',
    PICKUP_PENDING: 'Pickup Pending',
    OUT_FOR_PICKUP: 'Out for Pickup',
    PICKED_UP: 'Picked Up',
    INTRANSIT: 'In Transit',
    OUT_FOR_DELIVERY: 'Out for Delivery',
    DELIVERED: 'Delivered',
    FAILED_DELIVERY: 'Delivery Failed',
    RTO: 'Returning to Seller',
    RTO_INTRANSIT: 'RTO In Transit',
    RTO_OUT_FOR_DELIVERY: 'RTO Out for Delivery',
    RTO_DELIVERED: 'Returned to Seller',
  };

  const STATUS_ICONS = {
    DELIVERED: '\u2705',
    OUT_FOR_DELIVERY: '\uD83D\uDCCD',
    INTRANSIT: '\uD83D\uDE9A',
    PICKED_UP: '\uD83D\uDCE6',
    ORDER_PLACED: '\u2713',
    RTO: '\u21A9\uFE0F',
    FAILED_DELIVERY: '\u26A0\uFE0F',
  };

  function getStepIndex(status) {
    const s = (status || '').toUpperCase();
    if (s.includes('DELIVERED') && !s.includes('RTO') && !s.includes('FAILED')) return 4;
    if (s.includes('OUT_FOR_DELIVERY') && !s.includes('RTO')) return 4;
    if (s.includes('FAILED_DELIVERY')) return 3;
    if (s.includes('INTRANSIT') && !s.includes('RTO')) return 3;
    if (s.includes('PICKED')) return 2;
    return 1;
  }

  function formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  }

  function formatDateTime(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  }

  // DOM
  const input = document.getElementById('sok-track-input');
  const btn = document.getElementById('sok-track-btn');
  const formEl = document.getElementById('sok-track-form');
  const loadingEl = document.getElementById('sok-track-loading');
  const errorEl = document.getElementById('sok-track-error');
  const errorMsg = document.getElementById('sok-track-error-msg');
  const resultsEl = document.getElementById('sok-track-results');

  function showState(state) {
    formEl.classList.remove('hidden');
    loadingEl.classList.add('hidden');
    errorEl.classList.add('hidden');
    resultsEl.classList.add('hidden');
    if (state === 'loading') { loadingEl.classList.remove('hidden'); formEl.classList.add('hidden'); }
    if (state === 'error') { errorEl.classList.remove('hidden'); }
    if (state === 'results') { resultsEl.classList.remove('hidden'); formEl.classList.add('hidden'); }
  }

  async function trackOrder() {
    let orderId = input.value.trim().replace('#', '').replace(/SOK/i, '').trim();
    if (!orderId) {
      errorMsg.textContent = 'Please enter an order number';
      showState('error');
      return;
    }

    showState('loading');
    btn.disabled = true;

    try {
      // Fetch tracking + order details in parallel
      const [trackRes, detailsRes] = await Promise.all([
        fetch(`${API_BASE}/v1/orders/track?orderId=${orderId}`, {
          headers: { 'Authorization': `Bearer ${AUTH_TOKEN}` },
        }),
        fetch(`${API_BASE}/v1/orders/${orderId}`, {
          headers: { 'Authorization': `Bearer ${AUTH_TOKEN}` },
        }),
      ]);

      const trackData = await trackRes.json();
      const detailsData = await detailsRes.json();

      if (!trackData.success) {
        errorMsg.textContent = trackData.message || 'Order not found. Please check your order number.';
        showState('error');
        return;
      }

      // Check if order is cancelled (no tracking, no fulfillment)
      if (trackData.fulfillmentStatus === 'unfulfilled' && !trackData.waybill && !trackData.tracking) {
        errorMsg.textContent = 'This order has not been shipped yet. Tracking will be available once shipped.';
        showState('error');
        return;
      }

      renderResults(trackData);
      if (detailsData.success) {
        renderOrderDetails(detailsData);
      }
      showState('results');
    } catch (err) {
      errorMsg.textContent = 'Unable to fetch tracking details. Please try again later.';
      showState('error');
    } finally {
      btn.disabled = false;
    }
  }

  function renderOrderDetails(data) {
    const itemsEl = document.getElementById('sok-track-items');
    const addressEl = document.getElementById('sok-track-address');

    // Channel Info
    const source = data.source || data.channel || null;
    const externalOrderId = data.externalOrderId || null;
    
    let channelHtml = '';
    if (source || externalOrderId) {
      channelHtml = `
        <div class="sok-track__channel-info">
          ${source ? `<span class="sok-track__channel-badge">${source === 'YES_MADAM' || source.toLowerCase().includes('ym') ? 'Yes Madam Order' : source}</span>` : ''}
          ${externalOrderId ? `<span class="sok-track__channel-id">ID: ${externalOrderId}</span>` : ''}
        </div>
      `;
    }

    // Order Items
    const lineItems = data.lineItems || [];
    let itemsHtml = `
      <div class="sok-track__detail-header">
        <span class="sok-track__detail-title">\uD83D\uDCE6 Order Items (${lineItems.length})</span>
      </div>
    `;

    // Add channel info above items
    if (source || externalOrderId) {
      itemsHtml = `
        <div class="sok-track__channel-info">
          ${source ? `<span class="sok-track__channel-badge">${source === 'YES_MADAM' || source.toLowerCase().includes('ym') ? 'Yes Madam Order' : source}</span>` : ''}
          ${externalOrderId ? `<span class="sok-track__channel-id">ID: ${externalOrderId}</span>` : ''}
        </div>
      ` + itemsHtml;
    }

    lineItems.forEach(item => {
      itemsHtml += `
        <div class="sok-track__item">
          <div class="sok-track__item-info">
            <p class="sok-track__item-name">${item.title || ''}</p>
            <div class="sok-track__item-meta">
              <span class="sok-track__item-qty">Qty: ${item.quantity || 1}</span>
              <span class="sok-track__item-price">\u20B9${Math.round(parseFloat(item.price || 0))}</span>
            </div>
          </div>
        </div>
      `;
    });

    itemsEl.innerHTML = itemsHtml;

    // Delivery Address
    const addr = data.shippingAddress || {};
    const customer = data.customer || {};

    let addrHtml = `
      <div class="sok-track__detail-header">
        <span class="sok-track__detail-title">\uD83D\uDCCD Delivery Address</span>
      </div>
      <p class="sok-track__address-name">${addr.name || customer.name || ''}</p>
      <p class="sok-track__address-text">
        ${addr.address1 || ''}${addr.address2 ? ', ' + addr.address2 : ''}<br>
        ${addr.city || ''}${addr.province ? ', ' + addr.province : ''} \u2014 ${addr.zip || addr.pincode || ''}<br>
        ${addr.country || ''}
      </p>
      <p class="sok-track__address-phone">Phone: ${addr.phone || customer.phone || ''}</p>
    `;

    addressEl.innerHTML = addrHtml;
  }

  function renderResults(data) {
    const waybillDetail = data.tracking?.waybillDetails?.[0];
    const currentStatus = waybillDetail?.currentStatus || 'ORDER_PLACED';
    const carrier = waybillDetail?.courierPartner || waybillDetail?.courierPartnerParent || 'Carrier';
    const waybill = data.waybill || waybillDetail?.waybill || '';
    const orderHistory = waybillDetail?.order_history || [];
    const currentStep = getStepIndex(currentStatus);
    const edd = waybillDetail?.edd || waybillDetail?.customEdd || null;
    const isRTO = currentStatus.includes('RTO');

    // Confirmed Card
    const confirmedIcon = document.getElementById('sok-track-confirmed-icon');
    const confirmedTitle = document.getElementById('sok-track-confirmed-title');
    const confirmedSub = document.getElementById('sok-track-confirmed-sub');

    if (currentStep === 4) {
      confirmedIcon.className = 'sok-track__confirmed-icon sok-track__confirmed-icon--delivered';
      confirmedIcon.innerHTML = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      confirmedTitle.textContent = 'Order Delivered';
      confirmedSub.textContent = 'Your order has been delivered successfully. Enjoy your glow!';
    } else if (isRTO) {
      confirmedIcon.className = 'sok-track__confirmed-icon sok-track__confirmed-icon--rto';
      confirmedIcon.innerHTML = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path></svg>';
      confirmedTitle.textContent = 'Returned to Seller';
      confirmedSub.textContent = 'Your order has been returned to the seller.';
    } else if (currentStatus === 'FAILED_DELIVERY') {
      confirmedIcon.className = 'sok-track__confirmed-icon sok-track__confirmed-icon--failed';
      confirmedIcon.innerHTML = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>';
      confirmedTitle.textContent = 'Delivery Failed';
      confirmedSub.textContent = 'We could not deliver your shipment in our last delivery attempt. Please contact the customer service.';
    } else if (currentStep >= 3) {
      confirmedIcon.className = 'sok-track__confirmed-icon sok-track__confirmed-icon--shipped';
      confirmedIcon.innerHTML = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
      confirmedTitle.textContent = 'In Transit';
      confirmedSub.textContent = 'Your order is on its way. Sit back and relax!';
    } else if (currentStep >= 2) {
      confirmedIcon.className = 'sok-track__confirmed-icon sok-track__confirmed-icon--shipped';
      confirmedIcon.innerHTML = '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>';
      confirmedTitle.textContent = 'Order Shipped';
      confirmedSub.textContent = 'Your order has been picked up and is being shipped.';
    } else {
      confirmedIcon.className = 'sok-track__confirmed-icon';
      confirmedTitle.textContent = 'Order Confirmed';
      confirmedSub.textContent = "Thank you for the purchase. We've received your order and your glow is being prepared.";
    }

    // Order Info Bar
    document.getElementById('sok-track-info-order').textContent = `Order ${data.shopifyOrderNumber || '#' + data.orderId}`;
    const createdEvent = orderHistory.find(e => e.orderStatusEnum === 'ORDER_PLACED' || e.orderStatusEnum === 'AWB_REGISTERED');
    document.getElementById('sok-track-info-date').textContent = `Confirmed ${formatDate(createdEvent?.timestamp || '')}`;

    // Payment badge
    const badgeEl = document.getElementById('sok-track-info-badge');
    const paymentMode = waybillDetail?.paymentMode || '';
    if (paymentMode === 'COD') {
      badgeEl.textContent = 'COD';
      badgeEl.className = 'sok-track__info-badge sok-track__info-badge--cod';
    } else {
      badgeEl.textContent = '\u2713 Paid';
      badgeEl.className = 'sok-track__info-badge';
    }

    // Total
    const invoiceValue = waybillDetail?.invoiceValue || '';
    document.getElementById('sok-track-info-total').textContent = invoiceValue ? `\u20B9${Math.round(invoiceValue)}` : '';

    // Carrier + AWB
    document.getElementById('sok-track-carrier').textContent = carrier;
    const awbEl = document.getElementById('sok-track-awb');
    awbEl.textContent = waybill;
    awbEl.href = waybill ? `https://tracking.proship.in/?awbNo=${waybill}` : '#';
    awbEl.target = '_blank';

    // Status Badge
    const statusBadge = document.querySelector('.sok-track__carrier-badge');
    const statusIcon = currentStep === 4 ? '\u2713' : (isRTO ? '\u21A9' : (currentStatus === 'FAILED_DELIVERY' ? '' : '\u2192'));
    const statusLabel = STATUS_LABELS[currentStatus] || currentStatus;
    statusBadge.className = `sok-track__carrier-badge${currentStep === 4 ? ' sok-track__carrier-badge--delivered' : ''}${isRTO ? ' sok-track__carrier-badge--rto' : ''}${currentStatus === 'FAILED_DELIVERY' ? ' sok-track__carrier-badge--failed' : ''}`;
    document.querySelector('.sok-track__carrier-badge-icon').textContent = statusIcon;
    document.getElementById('sok-track-status-text').textContent = statusLabel;

    // Status Message
    let msg = '';
    const msgIcon = document.querySelector('.sok-track__message-icon');
    if (isRTO) {
      msg = 'Your order is being returned to the seller.';
      msgIcon.textContent = '\u21A9';
    } else if (currentStatus === 'FAILED_DELIVERY') {
      msg = 'Delivery attempt was unsuccessful. We will reattempt delivery soon.';
      msgIcon.textContent = '\u2717';
    } else if (currentStep === 4) {
      const deliveredEvent = orderHistory.find(e => e.orderStatusEnum === 'DELIVERED');
      msg = `Your order was delivered on ${formatDate(deliveredEvent?.timestamp || waybillDetail?.statusDate)}`;
      msgIcon.textContent = '\u2713';
    } else if (currentStep === 3) {
      msg = edd ? `Your order is on its way \u2014 expected delivery on or before ${formatDate(edd)}` : 'Your order is on its way!';
      msgIcon.textContent = '\u2192';
    } else if (currentStep === 2) {
      msg = 'Your order has been picked up and is being shipped.';
      msgIcon.textContent = '\u2192';
    } else {
      msg = 'Your order has been confirmed and is being prepared.';
      msgIcon.textContent = '\u2713';
    }
    document.getElementById('sok-track-message-text').textContent = msg;

    // Progress Bar
    const progressEl = document.getElementById('sok-track-progress');
    const totalSteps = STEPS.length;
    const fillPercent = currentStep >= totalSteps ? 100 : ((currentStep - 1) / (totalSteps - 1)) * 100;

    // Get dates for steps
    const stepDates = {};
    orderHistory.forEach(event => {
      const key = event.orderStatusEnum;
      if (key === 'ORDER_PLACED' || key === 'AWB_REGISTERED') stepDates['ORDER_PLACED'] = stepDates['ORDER_PLACED'] || formatDate(event.timestamp);
      if (key === 'PICKED_UP') stepDates['PICKED_UP'] = stepDates['PICKED_UP'] || formatDate(event.timestamp);
      if (key === 'INTRANSIT') stepDates['INTRANSIT'] = stepDates['INTRANSIT'] || formatDate(event.timestamp);
      if (key === 'OUT_FOR_DELIVERY') stepDates['INTRANSIT'] = stepDates['INTRANSIT'] || formatDate(event.timestamp);
      if (key === 'DELIVERED') stepDates['DELIVERED'] = stepDates['DELIVERED'] || formatDate(event.timestamp);
    });

    if (edd && currentStep < 4) {
      stepDates['DELIVERED'] = `Est. ${formatDate(edd)}`;
    }

    const checkSvg = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

    let progressHtml = `<div class="sok-track__progress-bar">`;
    progressHtml += `<div class="sok-track__progress-fill" style="width:${fillPercent}%"></div>`;

    STEPS.forEach((step, i) => {
      const done = i + 1 <= currentStep;
      const isCurrent = i + 1 === currentStep;
      const cls = done ? 'sok-track__progress-step--done' : (isCurrent ? 'sok-track__progress-step--current' : '');
      const date = stepDates[step.key] || '';

      progressHtml += `
        <div class="sok-track__progress-step ${cls}">
          <div class="sok-track__progress-dot">${done ? checkSvg : ''}</div>
          <span class="sok-track__progress-label">${step.label}</span>
          ${date ? `<span class="sok-track__progress-date">${date}</span>` : ''}
        </div>
      `;
    });

    progressHtml += '</div>';
    progressEl.innerHTML = progressHtml;

    // Timeline
    const timelineEl = document.getElementById('sok-track-timeline');
    const timelineCard = document.getElementById('sok-track-timeline-card');

    // Deduplicate and show key events (latest first)
    const keyEvents = [];
    const seenStatuses = new Set();
    const reversedHistory = [...orderHistory].reverse();

    reversedHistory.forEach(event => {
      const key = event.orderStatusEnum;
      if (!seenStatuses.has(key)) {
        seenStatuses.add(key);
        keyEvents.push(event);
      }
    });

    const eventsToShow = keyEvents.slice(0, 8);

    if (eventsToShow.length > 0) {
      timelineCard.classList.remove('hidden');
      let timelineHtml = '';
      eventsToShow.forEach(event => {
        const label = STATUS_LABELS[event.orderStatusEnum] || event.orderStatusDescription || event.orderStatusEnum;
        const time = formatDateTime(event.timestamp);
        const location = event.currentLocation || '';

        timelineHtml += `
          <div class="sok-track__event${event.orderStatusEnum === 'FAILED_DELIVERY' ? ' sok-track__event--failed' : ''}">
            <div class="sok-track__event-time">${time}</div>
            <div class="sok-track__event-status">${label}</div>
            ${location ? `<div class="sok-track__event-location">${location}</div>` : ''}
          </div>
        `;
      });
      timelineEl.innerHTML = timelineHtml;
    } else {
      timelineCard.classList.add('hidden');
    }
  }

  // Events
  btn.addEventListener('click', trackOrder);
  input.addEventListener('keypress', function(e) { if (e.key === 'Enter') trackOrder(); });

  // Track another order button
  const trackAnotherBtn = document.getElementById('sok-track-another-btn');
  if (trackAnotherBtn) {
    trackAnotherBtn.addEventListener('click', function() {
      input.value = '';
      showState('form');
      window.history.replaceState({}, '', window.location.pathname);
      input.focus();
    });
  }

  // URL params
  const urlParams = new URLSearchParams(window.location.search);
  const orderParam = urlParams.get('order') || urlParams.get('orderId') || urlParams.get('id');
  if (orderParam) {
    input.value = orderParam;
    trackOrder();
  }
})();
